var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panels',{attrs:{"focusable":""}},[_vm._t("faqs-items",[_vm._l((_vm.faqsItems),function(faq){return [_c('faqs-item',{key:faq.id,attrs:{"question":faq,"lang_key":faq.lang_key}})]})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }